export default __webpack_public_path__ + "static/media/Ellipse 254.73e33020.svg";